import React from 'react';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { RuleGroup, type RuleGroupProps } from 'react-querybuilder';
import { generateRuleByFieldSchema } from '../utils';
import * as Styled from './styled';
import { Combinator } from '../styled';
import { type QueryBuilderContext } from '../types';

const RuleGroupSection = (props: RuleGroupProps) => {
  const { path, context } = props;
  const { initialField, addRule } = context as QueryBuilderContext;
  const firstLevel = Boolean(!path?.length);

  if (firstLevel) {
    return <RuleGroup {...props}/>;
  }

  const rule = generateRuleByFieldSchema(initialField);
  const handleOnClick = () => addRule(rule, path);

  return (
    <Styled.RuleGroupSection>
      <Combinator style={{marginLeft: '23px'}}>AND</Combinator>
      <Styled.RuleGroupContainer>
        <RuleGroup {...props} />
        <Button
          ghost
          type="primary"
          style={{width: '70px', margin: '0px 0px 10px 57px'}}
          onClick={handleOnClick}
          icon={<PlusOutlined />}
        >
          OR
        </Button>
      </Styled.RuleGroupContainer>
    </Styled.RuleGroupSection>
  );
};

export default React.memo(RuleGroupSection);
